<template>
  <div>
    <p class="ma-0 font-13">
      <span class="font-weight-medium">Formato do arquivo:</span>
      <span class="pl-1 text-azul-link text-decoration-underline cursor-pointer" @click="baixarArquivo">baixar modelo</span>
    </p>
  </div>
</template>

<script>
import $axios from "@/api/api";

export default {
  name: "BaixarModeloArquivo",
  props: {
    url_download_modelo: {
      required: true,
      type: String
    }
  },
  methods: {
    baixarArquivo() {
      let url = `${$axios.defaults.baseURL}/${this.url_download_modelo}`;
      window.open(url, "_blank");
    }
  }
}
</script>

<style scoped>
.text-azul-link {
  color: #077ce7;
}
</style>
